export default {
  top_message: {
    first_line: {
      loan_installment_in_default_payment_plan_on_time:                'Ops, você tem parcela(s) em atraso.',
      loan_installment_in_default_payment_plan_installment_in_default: 'Ops, você tem um acordo vencido e parcela(s) em atraso.',
      loan_installments_on_time_payment_plan_installment_in_default:   'Ops, você tem um acordo vencido.',
      loan_installments_on_time:                                       'Tudo ok por aqui!',
    },
    second_line: {
      loan_installment_in_default:                                   'Regularize suas pendências ainda hoje para deixar seu contrato em dia.',
      loan_installments_on_time_payment_plan_installment_in_default: 'Regularize suas pendências ainda hoje para deixar seu contrato em dia.',
      loan_installments_not_in_default:                              'Você está em dia com as suas parcelas.',
    },
  },
  installment:        'Parcela',
  date:               'Vencimento',
  original_debt:      'Valor em aberto da parcela',
  outstanding_amount: 'Valor da divida*',
  status:             'Status',
  bottom_message:     'Seu empréstimo encontra-se em dia! Caso queira adiantar o pagamento, entre em contato com o nosso atendimento através do Whatsapp (11) 3335-2976.',
  top_tab:            'Meu empréstimo atual',
  bottom_button_text: 'Faça um pagamento',
  view_more:          'Ver Mais',
  view_less:          'Ver Menos',
};
